module.exports = __webpack_public_path__ + "machine-chip.1c7f2ed3c8f503c2573b964e2dec733c.hashedasset.svg";